import React from 'react';
import makeStyles from '@material-ui/core/styles/makeStyles';

import Card from '@material-ui/core/Card';
import CardHeader from '@material-ui/core/CardHeader';
import CardContent from '@material-ui/core/CardContent';
import Switch from '@material-ui/core/Switch';
import Typography from '@material-ui/core/Typography';

import HelpArticleLink from 'components/Page/HelpArticleLink';

import * as Types from 'pages/General/typings';

interface Props {
  values: Types.GeneralValues;
  onChange: (field: string, value: any) => void;
}

function DottedLineRelationships({ values, onChange }: Props) {
  const classes = useStyles();

  const handleChangeEnableDottedLineRelationships = () => {
    onChange(
      'client.settings.dottedLineRelationships.enabled',
      !values.client.settings.dottedLineRelationships.enabled,
    );
  };

  const handleChangeUserEditableDottedLineRelationships = () => {
    onChange(
      'client.settings.dottedLineRelationships.userEditable',
      !values.client.settings.dottedLineRelationships.userEditable,
    );
  };

  return (
    <Card>
      <CardHeader
        className={classes.cardHeader}
        title="Dotted Line Relationships"
        subheader={
          <div className={classes.subheader}>
            Dotted line relationships allow informal managers, direct reports, and teammates to be
            added to people and displayed on the Org Chart and Profile pages.
            <HelpArticleLink
              text="Learn More About Dotted Line Relationships ❯"
              link="http://help.justsift.com/en/articles/8986075-connecting-yourself-and-others-with-dotted-line-relationships "
            />
          </div>
        }
        action={
          <Switch
            checked={values.client.settings.dottedLineRelationships.enabled}
            onChange={handleChangeEnableDottedLineRelationships}
          />
        }
      />
      <CardContent className={classes.cardContent}>
        <Typography className={classes.adminOnlySwitchLabel}>
          Do you want to allow all users to add dotted line relationships to themselves and their
          direct reports? If switched off, only administrators will be able to add dotted line
          relationships.
        </Typography>

        <Switch
          checked={
            values.client.settings.dottedLineRelationships.userEditable &&
            values.client.settings.dottedLineRelationships.enabled
          }
          onChange={handleChangeUserEditableDottedLineRelationships}
          disabled={!values.client.settings.dottedLineRelationships.enabled}
        />
      </CardContent>
    </Card>
  );
}

const useStyles = makeStyles(theme => ({
  root: {},
  subheader: {
    display: 'flex',
    flexDirection: 'column',
  },
  cardHeader: {
    paddingBottom: theme.spacing(2),
  },
  cardContent: {
    display: 'flex',
    paddingTop: 0,
    paddingRight: theme.spacing(2),
  },
  adminOnlySwitchLabel: {
    marginRight: theme.spacing(),
  },
}));

export default DottedLineRelationships;
